import type { Node } from "interfaces/schemas";
import * as treeUtils from "utils/treeUtils";

export const calculateOpenMap = (nodes: Node[]) => {
  const map: Record<string, boolean> = {};
  const traverse = (node: Node) => {
    if (treeUtils.isWizard(node) && !treeUtils.isAnyProduct(node)) {
      if (!(node.id in map)) {
        map[node.id] = false;
      }
    }
    node.nodes?.forEach(traverse);
  };
  nodes.forEach(traverse);
  return map;
};
